module.exports = __webpack_public_path__ + "static/media/14UNEP3.aec3507f.jpg";